// ----------------------------------------------------------------------

// Vão entre abas, em unidades de spacing do tema. A margem desenha o vão e os pseudo-elementos
// o devolvem ao clique, por isso os dois leem daqui.
const TAB_GAP = { xs: 3, sm: 5 };

export default function Tabs(theme) {
  const halfGap = (gap) => theme.spacing(gap / 2);

  return {
    MuiTabs: {
      defaultProps: {
        textColor: 'inherit',
        allowScrollButtonsMobile: true,
        variant: 'scrollable',
      },
      styleOverrides: {
        scrollButtons: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        iconPosition: 'start',
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          padding: 0,
          opacity: 1,
          minWidth: 48,
          // O MUI corta o que sai da caixa do botão; a extensão abaixo vive fora dela.
          overflow: 'visible',
          fontWeight: theme.typography.fontWeightMedium,
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(TAB_GAP.xs),
            [theme.breakpoints.up('sm')]: {
              marginRight: theme.spacing(TAB_GAP.sm),
            },
          },
          // Margem não recebe clique: sem isto, o clique que erra o rótulo por poucos pixels
          // morre no vão. Cada aba ganha a metade do vão que encosta nela, fora da caixa do
          // botão, para o indicador (que mede a caixa) e o espaçamento visual não mudarem.
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: halfGap(TAB_GAP.xs),
            [theme.breakpoints.up('sm')]: {
              width: halfGap(TAB_GAP.sm),
            },
          },
          '&::before': {
            right: '100%',
          },
          '&::after': {
            left: '100%',
          },
          '&:first-of-type::before, &:last-of-type::after': {
            display: 'none',
          },
          '&:not(.Mui-selected)': {
            color: theme.palette.text.secondary,
          },
          ...((ownerState.iconPosition === 'start' || ownerState.iconPosition === 'end') && {
            minHeight: 48,
          }),
        }),
      },
    },
  };
}
